import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class SponsorService {

  constructor(
    private httpSv: HttpService,
    private navCtrl: NavController
  ) { }

  async getSponsor(id){
    let galleries = undefined;
    let products = undefined;
    this.httpSv.loadingIndicatorSrc.next(true);
    const res: any = await this.httpSv.getProduct( id, 'sponsors');
    if(res.galleries.length === 1){
      await this.navCtrl.navigateForward(`gallery/${res.galleries[0].id}`);
    }else{
      galleries = res.galleries;
    }
    products = res?.products;
    this.httpSv.loadingIndicatorSrc.next(false);
    return { galleries, products };
  }
}
